import * as React from "react";
import { SVGProps } from "react";
export function SeniorityIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 19.814 19.928"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.907 9.964a4.892 4.892 0 0 0 3.38-1.34 4.475 4.475 0 0 0 1.4-3.233 4.475 4.475 0 0 0-1.4-3.234A4.892 4.892 0 0 0 9.907.818a4.892 4.892 0 0 0-3.38 1.34 4.475 4.475 0 0 0-1.4 3.233c0 1.213.504 2.376 1.4 3.234a4.892 4.892 0 0 0 3.38 1.34Zm9.09 9.146a9.164 9.164 0 0 0-3.465-4.588 9.84 9.84 0 0 0-5.625-1.755 9.839 9.839 0 0 0-5.625 1.754 9.161 9.161 0 0 0-3.464 4.59h18.178Z"
        stroke="#000"
        strokeWidth={1.636}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
